/** Artboard 1 · Acceso — the only anonymous screen. Sign-in is Static Web Apps' Entra provider; the app never sees a password. */
import { useLocation } from 'react-router-dom';
import { loginUrl } from '../state/auth.ts';
import { Icon, Microsoft } from '../theme/ui.tsx';

export default function Acceso() {
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? '/';
  return (
    <div className="screen">
      <div className="phone" style={{ padding: '0 28px' }}>
        <div className="grow" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 18 }}>
          <div style={{ width: 56, height: 56, border: '2px solid var(--ink)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon.Receipt size={28} width={1.8} /></div>
          <div>
            <div style={{ fontSize: 34, fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.05 }}>Gastos</div>
            <div style={{ fontSize: 15.5, color: 'var(--ink-2)', marginTop: 12, lineHeight: 1.5, maxWidth: 290 }}>Guarda tus comprobantes de gastos. Nosotros conseguimos las facturas.</div>
          </div>
        </div>
        <div style={{ paddingBottom: 'calc(44px + var(--safe-b))', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <a className="btn btn--primary" style={{ minHeight: 54, gap: 11 }} href={loginUrl(from)}><Microsoft />Continuar con Microsoft</a>
          <div style={{ fontSize: 13, color: 'var(--ink-2)', textAlign: 'center', lineHeight: 1.45 }}>Usa la cuenta de la empresa.<br />No guardamos ninguna contraseña.</div>
        </div>
      </div>
    </div>
  );
}
